import { crearReducerDeFormulas } from './crearReducerDeFormulas'
import {
  UPDATE_CONFIGPRICE_FILTERS,
  CONFIGPRICE_LIST_REQUEST,
  CONFIGPRICE_LIST_SUCCESS,
  CONFIGPRICE_LIST_FAILURE,
  SELECT_CONFIGPRICE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  CONFIGPRICE_DELETE_REQUEST,
  CONFIGPRICE_DELETE_FAILURE,
  CONFIGPRICE_DELETE_SUCCESS,
  CONFIGPRICE_DETAIL_REQUEST,
  CONFIGPRICE_DETAIL_SUCCESS,
  CONFIGPRICE_DETAIL_FAILURE,
  CONFIGPRICE_CREATE_FAILURE,
  CONFIGPRICE_UPDATE_FAILURE,
  CONFIGPRICE_UPDATE_SUCCESS,
  CONFIGPRICE_UPDATE_REQUEST,
  CONFIGPRICE_CREATE_SUCCESS,
  RESET_CONFIGPRICE
} from '../../actions/ConfigPriceActions'

/**
 * Estado del listado de **precios**.
 *
 * Desde la Fase 6 comparte implementación con el de costos a través de
 * `crearReducerDeFormulas`, pero cada uno vive en su propio trozo del store.
 * Antes eran **el mismo**, y de ahí salían los cruces documentados en H7.
 */
export default crearReducerDeFormulas({
  tipos: {
    LISTA_PETICION: CONFIGPRICE_LIST_REQUEST,
    LISTA_EXITO: CONFIGPRICE_LIST_SUCCESS,
    LISTA_FALLO: CONFIGPRICE_LIST_FAILURE,
    DETALLE_PETICION: CONFIGPRICE_DETAIL_REQUEST,
    DETALLE_EXITO: CONFIGPRICE_DETAIL_SUCCESS,
    DETALLE_FALLO: CONFIGPRICE_DETAIL_FAILURE,
    ACTUALIZAR_FILTROS: UPDATE_CONFIGPRICE_FILTERS,
    EDICION_PETICION: CONFIGPRICE_UPDATE_REQUEST,
    EDICION_EXITO: CONFIGPRICE_UPDATE_SUCCESS,
    EDICION_FALLO: CONFIGPRICE_UPDATE_FAILURE,
    BORRADO_PETICION: CONFIGPRICE_DELETE_REQUEST,
    BORRADO_EXITO: CONFIGPRICE_DELETE_SUCCESS,
    BORRADO_FALLO: CONFIGPRICE_DELETE_FAILURE,
    CREACION_EXITO: CONFIGPRICE_CREATE_SUCCESS,
    CREACION_FALLO: CONFIGPRICE_CREATE_FAILURE,
    SELECCIONAR: SELECT_CONFIGPRICE,
    REINICIAR: RESET_CONFIGPRICE,
    MOSTRAR_MENSAJE: SHOW_MESSAGE,
    OCULTAR_MENSAJE: HIDE_MESSAGE
  },
  rutaBase: '/configuration/prices'
})
